import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { UserSettings } from '../models/user-settings.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {
  constructor(private httpClient: HttpClient) {}

  getUserSettings(): Observable<UserSettings> {
    return this.httpClient.get(`${environment.apiUrl}/User/Settings`);
  }

  setUserSettings(data: UserSettings) {
    return this.httpClient.put(`${environment.apiUrl}/User/Settings`, data);
  }

  changeUserPassword(oldPassword: string, newPassword: string): Observable<ChangeUserPasswordResult> {
    const body = {
      OldPassword: oldPassword,
      NewPassword: newPassword,
      ConfirmPassword: newPassword // We have to send this, because MagiCore API needs it...
    };

    return this.httpClient.post(`${environment.apiUrl}/Core/Auth/Password/Change`, body).pipe(
      map(() => ChangeUserPasswordResult.Success),
      catchError((err: HttpErrorResponse) => {
        return of(err.status === 401 ? ChangeUserPasswordResult.IncorrectPassword : ChangeUserPasswordResult.Failed);
      })
    );
  }
}

export const enum ChangeUserPasswordResult {
  Success,
  IncorrectPassword,
  Failed
}
